// @ts-nocheck
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import navConfig from './NavConfig';
import driverConfig from './DriverConfig';
import { useAppSelector } from '../../store/hooks';
import { getAuthDetails, getUserType } from '../../store/state/authSlice';
import adminConfig from './AdminConfig';
import NoProfileAvatar from '../../assets/static/mock-images/logo/carrental-logo.png';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const currentUser = useAppSelector(getAuthDetails);
  const userType = useAppSelector(getUserType);
  const role = useAppSelector(getAuthDetails);
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ mb: 1.5, mx: 2.5, py: 3 }}>
        <Link underline="none" component={RouterLink} to="/dashboard">
          <AccountStyle>
            <Avatar src={NoProfileAvatar} alt="photoURL" />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {currentUser && currentUser.name}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {userType === 'UTSP'
                  ? 'Vendor'
                  : userType === 'UTLB'
                  ? 'Driver'
                  : role && role.roleIdName[0]}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>
      {userType &&  <NavSection
          navConfig={
            userType === 'UTSP'
              ? navConfig
              : userType === 'UTLB'
              ? driverConfig
              : adminConfig
          }
        />}
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
